export function bufferToBlob(buffer: BlobPart, mimeType = "application/pdf"): Blob {
  return new Blob([buffer], { type: mimeType });
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => window.URL.revokeObjectURL(url), 100);
}

export function downloadBuffer(
  buffer: BlobPart,
  filename: string,
  mimeType = "application/pdf"
): void {
  downloadBlob(bufferToBlob(buffer, mimeType), filename);
}

export function downloadFromUrl(url: string, filename: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
}

export function openBufferInTab(buffer: BlobPart, mimeType = "application/pdf"): void {
  window.open(window.URL.createObjectURL(bufferToBlob(buffer, mimeType)), "_blank");
}

export function navigateToBuffer(buffer: BlobPart, mimeType = "application/pdf"): void {
  const url = window.URL.createObjectURL(bufferToBlob(buffer, mimeType));
  const windowReference = window.open("", "_self");
  if (windowReference) {
    windowReference.location = url;
  }
}
